import Heading from "@elements/Typography/Heading";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export type ParagraphProps = {
  testid?: string;
  children: ReactNode;
  className?: string;
};

export default function Paragraph({
  testid,
  children,
  className,
}: ParagraphProps) {
  return (
    <p
      data-testid={testid}
      className={twMerge(
        "font-opensans text-grey-100 text-lg mb-4 font-normal leading-450 px-3 md:px-5 lg:px-0",
        className,
      )}
    >
      {children}
    </p>
  );
}

export function StandFirst({ children, className }: ParagraphProps) {
  return (
    <Heading
      className={twMerge(
        "text-grey-500 font-opensans font-bold text-lg leading-6.7",
        className,
      )}
      Element="h6"
    >
      {children}
    </Heading>
  );
}
